export const moreThan = (min, customMessage) => value =>
  value && value > min
    ? true
    : customMessage
    ? customMessage(min, value)
    : "O valor deve ser maior que " + min;

export const moreOrEqualThan = (min, customMessage) => value =>
  value && value >= min
    ? true
    : customMessage
    ? customMessage(min, value)
    : "O valor deve ser maior ou igual a " + min;

export const lessThan = (max, customMessage) => value =>
  value && value < max
    ? true
    : customMessage
    ? customMessage(max, value)
    : "O valor deve ser menor que " + max;

export const lessOrEqualThan = (max, customMessage) => value =>
  value && value <= max
    ? true
    : customMessage
    ? customMessage(max, value)
    : "O valor deve ser menor ou igual a " + max;

export const equalThan = (max, customMessage) => value =>
  value && value === max
    ? true
    : customMessage
    ? customMessage(max, value)
    : "O valor deve ser igual a " + max;
